import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import HorizontalLayoutContainer from '../../publicLayout/components/HorizontalLayoutContainer';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import PublicCatalogDropdown from './PublicCatalogDropdown';
import { dropdownFilters } from '../publicCatalogConstants';
import { useGetMainFilterApplied, useGetPathFilterApplied } from '../publicCatalogFiltersHooks';
import { getSubMenuNameFromSubMenuOption } from '../publicCatalogDropdownUtils';
import { useGetDropdownFilterApplied } from '../publicCatalogFiltersHooks';
import PublicCatalogResultsText from './PublicCatalogResultsText';
import { useGetCatalogResultsFromUrlFilters } from '../publicCatalogResultsHooks';
import { PAGE_SIZE } from './PublicCatalogResults';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { useTheme } from 'foundations-theming/utils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultsBarDropdowns = () => {
  const dropdownFilterAppliedInfo = useGetDropdownFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  if (pathFilterApplied) {
    return /*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.pathFilters.${pathFilterApplied}`
      }),
      buttonUse: "link-on-bright"
    });
  }
  if (!dropdownFilterAppliedInfo) return null;
  const {
    dropdownFilterApplied,
    dropdownFilterValue,
    isAppliedValueATopLevelOption
  } = dropdownFilterAppliedInfo;
  if (isAppliedValueATopLevelOption) {
    return /*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${dropdownFilterValue}`
      }),
      buttonUse: "link-on-bright"
    });
  }
  const subMenuName = getSubMenuNameFromSubMenuOption(dropdownFilterApplied, dropdownFilterValue);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${subMenuName}`
      }),
      buttonUse: "link-on-bright"
    }), /*#__PURE__*/_jsx(View, {
      as: "span",
      marginInline: "200",
      children: "/"
    }), /*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${dropdownFilterValue}`
      }),
      buttonUse: "link-on-bright",
      subMenuName: subMenuName || undefined
    })]
  });
};
const ResultsBarsSkeletonLoader = () => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "results-bar-loading",
      children: /*#__PURE__*/_jsx(ACSkeletonBox, {
        animated: true,
        backgroundcolor: trellisTheme.color['fill-surface-recessed'],
        shimmercolor: trellisTheme.color['fill-surface-default'],
        style: {
          width: '180px',
          height: '20px'
        }
      })
    })
  });
};
const PublicCatalogResultsBar = () => {
  const [searchParams] = useSearchParams();
  const mainFilterApplied = useGetMainFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  const {
    publicCatalogData,
    publicCatalogError,
    publicCatalogLoading
  } = useGetCatalogResultsFromUrlFilters({
    pageSize: PAGE_SIZE
  });
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    color: "text-core-default",
    "data-test-id": "search-results-bar",
    minBlockSize: "40px",
    paddingBlock: "100",
    children: /*#__PURE__*/_jsxs(Paragraph, {
      margin: "0",
      children: [publicCatalogLoading && /*#__PURE__*/_jsx(ResultsBarsSkeletonLoader, {}), !publicCatalogLoading && !publicCatalogError && publicCatalogData && /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsxs(TFlex, {
          children: [/*#__PURE__*/_jsx(Box, {
            shrink: 0,
            children: /*#__PURE__*/_jsx(PublicCatalogResultsText, {
              count: publicCatalogData.total || 0
            })
          }), /*#__PURE__*/_jsxs(Box, {
            marginInlineStart: "200",
            children: [mainFilterApplied === 'search' && /*#__PURE__*/_jsx(TruncateString, {
              display: "inline",
              children: searchParams.search
            }), (dropdownFilters.includes(mainFilterApplied) || pathFilterApplied) && /*#__PURE__*/_jsx(ResultsBarDropdowns, {})]
          })]
        })
      })]
    })
  });
};
export default PublicCatalogResultsBar;